import React from 'react';

const WarningIcon = ({ className }) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" className={className}>
    <rect width="24" height="24" rx="12" fill="#C7781D"/>
    <path d="M11.75 9.91406C12.3022 9.91406 12.7498 10.3619 12.75 10.9141V17.8008C12.7499 18.353 12.3022 18.8008 11.75 18.8008C11.1978 18.8007 10.7501 18.3529 10.75 17.8008V10.9141C10.7502 10.362 11.1979 9.91412 11.75 9.91406ZM11.7676 4.75C12.3197 4.7502 12.7676 5.19784 12.7676 5.75C12.7674 6.30199 12.3196 6.7498 11.7676 6.75H11.75C11.1979 6.74995 10.7502 6.30208 10.75 5.75C10.75 5.19775 11.1978 4.75005 11.75 4.75H11.7676Z" fill="#333333"/>
  </svg>
);

export default WarningIcon;
